// Add your custom JS here.
let docHeight = window.innerHeight;
let docWidth = window.innerWidth;
const galleryCheck = () => {
    let currentUrl = window.location.href;
    let linkParts = currentUrl.split("/");
    let currentLink = linkParts[linkParts.length - 2];
    console.log("currentUrl:", currentUrl, "currentLink: " + currentLink); 
    if (currentLink == "gallery" && docWidth < 834) {
        window.location.replace('mobile-gallery');
    }
    else  if (currentLink == "mobile-gallery" && docWidth > 833) {
        window.location.replace('gallery');
    } 
};
jQuery(function() {
    if (jQuery(".home-title") != undefined && jQuery(".home-title").offset() != undefined) {
        let logoHeight = jQuery(".home-logo").height();
        let homeTitleHeight = jQuery(".home-title").height();
        let homeTitleTop = jQuery(".home-title").offset().top;
        let homeTitleUpperLimit = 30 + logoHeight + 20;
        let heroHeightLimit = homeTitleTop +  homeTitleHeight + 200;
        if (docHeight < heroHeightLimit) {
            jQuery(".hero").height(heroHeightLimit);
        }
        else {        
            jQuery(".hero").height(docHeight);
        }
        if (docHeight < 400 && homeTitleTop < homeTitleUpperLimit) {
            let homeTitleTopMargin = homeTitleUpperLimit + "px";
            jQuery(".home-title").css("margin-top", homeTitleTopMargin);
        }
    }    
    if(window.location.hash == '#news' || window.location.hash == '#about' || window.location.hash == '#sponsors') {
        scrollNav(window.location.hash);
    }    
    galleryCheck();
});
jQuery('#city').change(function () {
    jQuery("#genre").val("all");
    jQuery(".show-row").hide();
    let optionSelected = jQuery(this).find("option:selected");
    let valueSelected  = optionSelected.val();
    if (valueSelected == "all") {
        jQuery(".show-row").show();
    } else {
        jQuery("."+valueSelected).show();
    }
});
jQuery('#genre').change(function () {
    jQuery("#city").val("all");
    jQuery(".show-row").hide();
    let optionSelected = jQuery(this).find("option:selected");
    let valueSelected  = optionSelected.val();
    if (valueSelected == "all") {
        jQuery(".show-row").show();
    } else {
        jQuery("."+valueSelected).show();
    }
});

/* SCROLLING NAV */
jQuery("#wpfront-scroll-top-container img").click(function() {  
    window.location.replace('');
});
const scrollNav = (navlink) => {
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery(navlink).offset().top
        });
        window.location.replace(navlink);
        jQuery("#wpfront-scroll-top-container").attr("style", "opacity: 0.7; display: block;");
};
jQuery(".news-btn").click(function(event) {
    event.preventDefault();
    scrollNav('#news');
});
jQuery("#rmp-menu-item-2614 a").click(function(event) {
    event.preventDefault();
    scrollNav('#news');
    jQuery("#rmp_menu_trigger-2622").click();
});
jQuery(".about-btn").click(function(event) {
    event.preventDefault();
    scrollNav('#about');
});
jQuery("#rmp-menu-item-2617 a").click(function(event) {
    event.preventDefault();
    scrollNav('#about');
    jQuery("#rmp_menu_trigger-2622").click();
});
jQuery(".sponsors-btn").click(function(event) {
    event.preventDefault();
    scrollNav('#sponsors');
});
jQuery("#rmp-menu-item-2621 a").click(function(event) {
    event.preventDefault();
    scrollNav('#sponsors');
    jQuery("#rmp_menu_trigger-2622").click();
});

/* MODAL JS */
// Get the modal
let modal = jQuery('#modalDialog');
// Get the button that opens the modal
let btn = jQuery(".modal-btn");
// Get the <span> element that closes the modal
let span = jQuery(".close");
// When the user clicks the button, open the modal 
btn.on('click', function(event) {
    event.preventDefault();
    let artistName = jQuery(this).text();
    let artistInfo = jQuery(this.dataset.artistInfo);
    jQuery(".modal-title").html(artistName);
    jQuery(".modal-body .content").html(artistInfo);
    modal.show();
});    
// When the user clicks on <span> (x), close the modal
span.on('click', function(event) {
    event.preventDefault();
    modal.fadeOut();
});
// When the user clicks anywhere outside of the modal, close it
jQuery('body').bind('click', function(e){
    if(jQuery(e.target).hasClass("modal")){
        modal.fadeOut();
    }
});

window.onresize = function(event) {
    galleryCheck();
};
